import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  isExecutiveDemoActive,
  MOCK_NATION_RIVALRY_ROWS,
  MOCK_LIVE_PULSE,
} from "@/lib/demo/executiveDemoMock";

/**
 * When ?demo=executive is active, seeds the React Query cache for the
 * `social.nation_rivalry` and `social.pulse_snap` keys. This unblocks
 * Cinematic Moments, NationLeaderboard (showcase), Global energy ribbon
 * and other surfaces that read from these queries — WITHOUT writing
 * anything to the database.
 */
export function ExecutiveDemoSeeder() {
  const qc = useQueryClient();

  useEffect(() => {
    if (!isExecutiveDemoActive()) return;

    const seed = () => {
      qc.setQueryData(["social", "nation_rivalry"], { rows: MOCK_NATION_RIVALRY_ROWS, error: null });
      qc.setQueryData(["social", "pulse_snap"], MOCK_LIVE_PULSE);
    };

    seed();
    const id = window.setInterval(seed, 10_000);
    return () => window.clearInterval(id);
  }, [qc]);

  return null;
}